const map = {
    0: {
        // Bugs
        1: {
            region: 'Wise Region',
            capital: 'New New York',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '', //active, captured, lost
            event: '', //defend, attack
            // event: '' //active || idle
        },
        2: {
            region: 'Kruger System',
            capital: 'Liberty City',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        3: {
            region: 'Ross System',
            capital: 'Tiberia',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },

        4: {
            region: 'Struve Region',
            capital: "Northman's Creek",
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        5: {
            region: 'Xi Tauri Region',
            capital: 'New Haven',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        6: {
            region: 'Cancri System',
            capital: 'Freedom Fortress',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        7: {
            region: 'Higgs Region',
            capital: "Martyr's Bay",
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        8: {
            region: 'Hawking Region',
            capital: 'Segma Prime',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        9: {
            region: 'Rigel System',
            capital: 'Freedom Peak',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        10: {
            region: 'Aurigae Region',
            capital: 'Final Frontier',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        11: {
            //Kepler System, Bugs Homeworld
            region: 'Kepler System',
            capital: 'Kepler Prime',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
    },
    1: {
        // Cyborgs
        1: {
            region: 'Sirius Region',
            capital: 'Stockholm City',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        2: {
            region: 'Polaris Region',
            capital: 'Thunder Head',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        3: {
            region: 'Pictor Sector',
            capital: 'New Moscow',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        4: {
            region: 'Sagan Region',
            capital: 'Highwind',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        5: {
            region: 'Horolium System',
            capital: 'Providence',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        6: {
            region: 'Gellert Region',
            capital: 'Gellert City',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        7: {
            region: 'Lacaille Region',
            capital: 'Bahia Democracia',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        8: {
            region: 'Indi System',
            capital: 'Winter Hold',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        9: {
            region: 'Ceti System',
            capital: 'Doral Creek',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        10: {
            region: 'Cygni Region',
            capital: 'New Berlin',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        11: {
            // //Cyberstan Region, Cyborgs Homeworld
            region: 'Cyberstan Region',
            capital: 'Cyberstan',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
    },
    2: {
        // The Illuminate
        1: {
            region: 'Centaury Region',
            capital: 'New Hanover',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        2: {
            region: 'Barnard Region',
            capital: 'Iron Tower',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        3: {
            region: 'Procyon Region',
            capital: 'White Landing',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        4: {
            region: 'Castor System',
            capital: 'Justice Bay',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        5: {
            region: 'Orionis Region',
            capital: 'New Alexandria',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        6: {
            region: 'Prometheus System',
            capital: 'Ribatishiti',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        7: {
            region: 'Cassiopaiae Region',
            capital: 'Dal Rage',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        8: {
            region: 'Ursa Region',
            capital: 'Ultima',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        9: {
            region: 'Canes Region',
            capital: 'Jiyu Toshi',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        10: {
            region: 'Arcturus Region',
            capital: 'Hawk Nest',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
        11: {
            // //Squ'bai System, The Illuminate Homeworld
            region: "Squ'bai System",
            capital: "Squ'bai Shrine",
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: '',
            event: '',
        },
    },
    3: {
        0: {
            region: 'Sol System',
            capital: 'Super Earth',
            percent: 0,
            points: 0,
            points_max: 0,
            points_sector: 0,
            points_sector_max: 0,
            status: 'captured', //active, captured, lost
            event: '', //defend, attack
        },
    },
};

export default map;
